import { i18nMark } from '@lingui/react'
import { bool, number, shape, string } from 'prop-types'

import IconArrowRight from 'views/components/atoms/Icon/IconArrowRight'
import PriceFrom from 'views/components/atoms/PriceFrom'
import ButtonWithIcon from 'views/components/molecules/ButtonWithIcon'
import TransWithHtml from 'views/components/utils/TransWithHtml'

const OfferBox = ({ offerTypeSae, bestOfferPrice, url, sellersCount }) => {
  const linkLabelOfferBoxKey = offerTypeSae
    ? i18nMark('offerBox.link.label.both')
    : i18nMark('offerBox.link.label.sellers.only')

  return (
    <div className="a-box a-box--bordered l-flex">
      <div className="l-flex__primary">
        <a href={url} className="a-link a-link--no-underline">
          <div className="u-font-weight--bold u-color--blue">
            <TransWithHtml
              id={linkLabelOfferBoxKey}
              element="span"
              values={{ count: sellersCount }}
            />
          </div>
        </a>
        <div className="a-h2 u-no-margin">
          <PriceFrom
            amount={bestOfferPrice.price}
            currency={bestOfferPrice.currency}
          />
        </div>
      </div>
      <ButtonWithIcon
        component="Button"
        icon={<IconArrowRight />}
        name="gotoOffersPage"
        href={url}
      />
    </div>
  )
}

OfferBox.propTypes = {
  bestOfferPrice: shape({ price: number, currency: string }).isRequired,
  url: string.isRequired,
  offerTypeSae: bool.isRequired,
  sellersCount: number.isRequired,
}

export default OfferBox
